import { z } from 'zod';

export const DistributionPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  status: z.string().min(1, 'Status is required'),
  amount: z.number().positive(),
  distribution_date: z.string().date(),
});

export type DistributionProps = z.infer<typeof DistributionPropsSchema>;
